export const HEADSTONE_STYLE_KEYS = ['standard', 'marble', 'obsidian', 'bronze', 'ivy'] as const;

export type HeadstoneStyleKey = (typeof HEADSTONE_STYLE_KEYS)[number];

export function isHeadstoneStyleKey(value: unknown): value is HeadstoneStyleKey {
  return typeof value === 'string' && (HEADSTONE_STYLE_KEYS as readonly string[]).includes(value);
}

export function tombstoneStyleClass(styleKey?: string | null): string {
  const key = isHeadstoneStyleKey(styleKey) ? styleKey : 'standard';
  return key === 'standard' ? 'tombstone' : `tombstone tombstone--${key}`;
}

export function styleLabelKey(styleKey: HeadstoneStyleKey): string {
  const map: Record<HeadstoneStyleKey, string> = {
    standard: 'pethernity.styleStandard',
    marble: 'pethernity.styleMarble',
    obsidian: 'pethernity.styleObsidian',
    bronze: 'pethernity.styleBronze',
    ivy: 'pethernity.styleIvy',
  };
  return map[styleKey];
}
